const INTERESTED_IN_LOAN_OFFER_GTM = 'interestedInLoanOffer';
import store from '../../../../common/js/vuex/store';
export const selectLoanMixin = {
	methods: {
		selectLahiLoanAndOpenModal(e, modalId, lahiProduct, postData, taEventPrefix) {
			let sessionId = store.state.lahi.sessionId;
			if (postData) {
				// VHK-t nyit
				this.$gtm.trackEvent({
					event: INTERESTED_IN_LOAN_OFFER_GTM,
					homeLoanName: lahiProduct.commonName,
					homeLoanBankRepayment: lahiProduct.installment,
					homeLoanInterestRate: lahiProduct.interest,
					homeLoanTHM: lahiProduct.thm
				});
				this.$modalEventBus.$emit('change-modal-width', { modalType: 'wide', modalId });
			}
			this.$modalEventBus.$emit('close-modal', 'lahi-details-modal');
			this.selectLahiLoan({ lahiProduct, postData, taEventPrefix });
			this.$nextTick(() => {
				this.$openModal(e, modalId);
				const event = new CustomEvent('call-request-lahi-set-payload', {
					detail: {
						sessionId: sessionId,
						lahiCalculationResult: lahiProduct
					}
				});
				window.dispatchEvent(event);
			});
		}
	}
};
